/**
 * Created by JackCui on 2021/2/1
 */

import { batchHandleUrl } from '../../utils/url-handle.js'

const paasEdit = {
  getPageRule: {
    url: '/apaas/rule/getPageRule',
    type: 'POST'
  },
  getRuleValue: {
    url: '/apaas/object/value/get/ruleValue',
    type: 'POST'
  },
  // 编辑值对象-详情
  getForUpdate: {
    url: '/apaas/object/value/getForUpdate',
    type: 'post'
  },
  // 编辑从对象-值详情
  getSlaveForUpdate: {
    url: '/apaas/object/value/getManyObjetValueForUpdate',
    type: 'post'
  },
  // 值对象-更新
  valueUpdate: {
    url: '/apaas/object/value/update',
    type: 'post'
  },
  // 值对象-创建
  valueCreate: {
    url: '/apaas/object/value/create',
    type: 'post'
  },
  // 值对象-批量创建
  valueBatchCreate: {
    url: '/apaas/object/value/batchCreate',
    type: 'post'
  }
}
export default batchHandleUrl(paasEdit)
